module.exports = __webpack_public_path__ + "7812785a06d904bdac1a8fb4f9a534f1.png";